import React from "react";

const BasicInformationForm = ({ formData, setFormData, handleNext }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    console.log(formData);
  };

  const handleSubmit = (e) => {
    e.preventDefault(); // ✅ Prevents page reload
    console.log("Submitted:", formData);
    sessionStorage.setItem("form", JSON.stringify(formData));
    handleNext(); // Navigate to next step
  };
  return (
    <form onSubmit={handleSubmit} className="w-full mx-auto rounded-lg">
      <div className="space-y-4">
        {/* Business Name */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Business name
          </label>
          <input
            type="text"
            name="business_name"
            placeholder="Enter business name"
            value={formData?.business_name || ""}
            // required
            onChange={handleChange}
            className="mt-1 w-full p-2 border rounded"
          />
        </div>

        {/* Business Type & Registration Number */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Business type
            </label>
            <input
              type="text"
              placeholder="Enter business type"
              name="business_type"
              value={formData?.business_type || ""}
              onChange={handleChange}
              required
              className="mt-1 w-full p-2 border rounded"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Business registration number
            </label>
            <input
              type="text"
              name="business_registration_number"
              placeholder="Enter registration number"
              value={formData?.business_registration_number || ""}
              onChange={handleChange}
              className="mt-1 w-full p-2 border rounded"
            />
          </div>
        </div>

        {/* Business Address */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Business address
          </label>
          <input
            type="text"
            name="business_address"
            placeholder="Enter business address"
            value={formData?.business_address || ""}
            onChange={handleChange}
            className="mt-1 w-full p-2 border rounded"
          />
        </div>

        {/* Email & Phone Number */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Email address
            </label>
            <input
              type="email"
              required
              name="business_email"
              placeholder="Enter email address"
              value={formData?.business_email || ""}
              onChange={handleChange}
              className="mt-1 w-full p-2 border rounded"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Business phone number
            </label>
            <div className="flex items-center border rounded p-2 mt-1">
              <input
                type="number"
                name="business_phone"
                placeholder="XXX - XXX - XXXX"
                value={formData?.business_phone || ""}
                onChange={handleChange}
                className="flex-1 pl-2 outline-none"
              />
            </div>
          </div>
        </div>
      </div>
      <button
        type="submit"
        className=" mt-4 w-full px-6 py-2 bg-blue-600 text-white rounded"
      >
        Next
      </button>
    </form>
  );
};

export default BasicInformationForm;
